/**
 * Auto-generated by generate-skill-defaults.ts – DO NOT EDIT MANUALLY.
 * Generated on: 2026-09-18T13:14:32.363Z
 *
 * Default skill selections per skill taxonomy (0 = default, others custom).
 * Ids are the custom-skill picker's ancestor-path ids; `levelId` is the
 * picker level (skill_0 = K150 … skill_3 = K15000) the defaults live on.
 */

export type SkillDefaultSelection = {
  id: string;
  name: string;
  levelId: 'skill_0' | 'skill_1' | 'skill_2' | 'skill_3';
};

/** Skill taxonomy version these defaults were generated against. */
export const GENERATED_SKILL_DEFAULTS_VERSION = '3.1.0';

// 0: default
export const GENERATED_DEFAULT_CUSTOM_SKILL_DEFAULT: SkillDefaultSelection[] = [
  {
    id: '28',
    name: 'Community Services',
    levelId: 'skill_0',
  },
  {
    id: '38',
    name: 'Customer Experience',
    levelId: 'skill_0',
  },
  {
    id: '42',
    name: 'Data Governance',
    levelId: 'skill_0',
  },
  {
    id: '103',
    name: 'Programming',
    levelId: 'skill_0',
  },
  {
    id: '105',
    name: 'Project Delivery',
    levelId: 'skill_0',
  },
];

// 1: rics_k50_1
export const GENERATED_DEFAULT_CUSTOM_SKILL_CUSTOM_1: SkillDefaultSelection[] =
  [
    {
      id: '11',
      name: 'Business Development',
      levelId: 'skill_0',
    },
    {
      id: '24',
      name: 'Community Services',
      levelId: 'skill_0',
    },
    {
      id: '108',
      name: 'Operations',
      levelId: 'skill_0',
    },
    {
      id: '114',
      name: 'Programming',
      levelId: 'skill_0',
    },
    {
      id: '115',
      name: 'Project Management Methodologies',
      levelId: 'skill_0',
    },
  ];

// 2: rics_k50_2
export const GENERATED_DEFAULT_CUSTOM_SKILL_CUSTOM_2: SkillDefaultSelection[] =
  [
    {
      id: '40',
      name: 'Data Analysis',
      levelId: 'skill_0',
    },
    {
      id: '51',
      name: 'Employee Training',
      levelId: 'skill_0',
    },
    {
      id: '107',
      name: 'Programming',
      levelId: 'skill_0',
    },
    {
      id: '108',
      name: 'Project Operations',
      levelId: 'skill_0',
    },
    {
      id: '118',
      name: 'Sales Management',
      levelId: 'skill_0',
    },
  ];

// 3: rics_k50_3
export const GENERATED_DEFAULT_CUSTOM_SKILL_CUSTOM_3: SkillDefaultSelection[] =
  [
    {
      id: '1',
      name: 'Account Management',
      levelId: 'skill_0',
    },
    {
      id: '87',
      name: 'Operations Performance Analysis',
      levelId: 'skill_0',
    },
    {
      id: '102',
      name: 'Project Planning',
      levelId: 'skill_0',
    },
    {
      id: '121',
      name: 'Software Development Practices',
      levelId: 'skill_0',
    },
    {
      id: '126',
      name: 'Staff Development',
      levelId: 'skill_0',
    },
  ];

// 4: rics_k50_4
export const GENERATED_DEFAULT_CUSTOM_SKILL_CUSTOM_4: SkillDefaultSelection[] =
  [
    {
      id: '13',
      name: 'Business Development',
      levelId: 'skill_0',
    },
    {
      id: '14',
      name: 'Business Planning',
      levelId: 'skill_0',
    },
    {
      id: '25',
      name: 'Community Leadership',
      levelId: 'skill_0',
    },
    {
      id: '117',
      name: 'Project Planning',
      levelId: 'skill_0',
    },
    {
      id: '129',
      name: 'Software Engineering',
      levelId: 'skill_0',
    },
  ];

// 5: rics_k50_5
export const GENERATED_DEFAULT_CUSTOM_SKILL_CUSTOM_5: SkillDefaultSelection[] =
  [
    {
      id: '11',
      name: 'BI Analytics',
      levelId: 'skill_0',
    },
    {
      id: '77',
      name: 'Java Development',
      levelId: 'skill_0',
    },
    {
      id: '111',
      name: 'Project Controls',
      levelId: 'skill_0',
    },
    {
      id: '121',
      name: 'Relationship Building',
      levelId: 'skill_0',
    },
    {
      id: '136',
      name: 'Strategic Sales',
      levelId: 'skill_0',
    },
  ];

// 6: rics_k50_6
export const GENERATED_DEFAULT_CUSTOM_SKILL_CUSTOM_6: SkillDefaultSelection[] =
  [
    {
      id: '15',
      name: 'Business Analytics',
      levelId: 'skill_0',
    },
    {
      id: '103',
      name: 'Personal Development',
      levelId: 'skill_0',
    },
    {
      id: '123',
      name: 'Sales Operations',
      levelId: 'skill_0',
    },
    {
      id: '130',
      name: 'Software Development Technical',
      levelId: 'skill_0',
    },
    {
      id: '138',
      name: 'Technology Project Management',
      levelId: 'skill_0',
    },
  ];

// 7: rics_k50_7
export const GENERATED_DEFAULT_CUSTOM_SKILL_CUSTOM_7: SkillDefaultSelection[] =
  [
    {
      id: '14',
      name: 'Business Development',
      levelId: 'skill_0',
    },
    {
      id: '17',
      name: 'Clinical Education',
      levelId: 'skill_0',
    },
    {
      id: '33',
      name: 'Data Quality',
      levelId: 'skill_0',
    },
    {
      id: '111',
      name: 'Project Delivery',
      levelId: 'skill_0',
    },
    {
      id: '129',
      name: 'Software Engineering',
      levelId: 'skill_0',
    },
  ];

// 8: rics_k50_8
export const GENERATED_DEFAULT_CUSTOM_SKILL_CUSTOM_8: SkillDefaultSelection[] =
  [
    {
      id: '15',
      name: 'Business Analytics',
      levelId: 'skill_0',
    },
    {
      id: '26',
      name: 'Community Services',
      levelId: 'skill_0',
    },
    {
      id: '54',
      name: 'Enterprise Backend Development',
      levelId: 'skill_0',
    },
    {
      id: '119',
      name: 'Sales Development',
      levelId: 'skill_0',
    },
    {
      id: '132',
      name: 'Technical Project Management',
      levelId: 'skill_0',
    },
  ];

// 9: rics_k50_9
export const GENERATED_DEFAULT_CUSTOM_SKILL_CUSTOM_9: SkillDefaultSelection[] =
  [
    {
      id: '6',
      name: 'Application Development',
      levelId: 'skill_0',
    },
    {
      id: '34',
      name: 'Data Analysis',
      levelId: 'skill_0',
    },
    {
      id: '97',
      name: 'Organizational Development',
      levelId: 'skill_0',
    },
    {
      id: '107',
      name: 'Project Management Fundamentals',
      levelId: 'skill_0',
    },
    {
      id: '118',
      name: 'Sales Techniques',
      levelId: 'skill_0',
    },
  ];

// 10: rics_k50_10
export const GENERATED_DEFAULT_CUSTOM_SKILL_CUSTOM_10: SkillDefaultSelection[] =
  [
    {
      id: '64',
      name: 'Financial Modeling',
      levelId: 'skill_0',
    },
    {
      id: '67',
      name: 'Full Stack Web Development',
      levelId: 'skill_0',
    },
    {
      id: '82',
      name: 'Learning and Development',
      levelId: 'skill_0',
    },
    {
      id: '102',
      name: 'Project Delivery',
      levelId: 'skill_0',
    },
    {
      id: '118',
      name: 'Sales Strategy',
      levelId: 'skill_0',
    },
  ];

// 11: rics_k50_11
export const GENERATED_DEFAULT_CUSTOM_SKILL_CUSTOM_11: SkillDefaultSelection[] =
  [
    {
      id: '3',
      name: 'Account Management',
      levelId: 'skill_0',
    },
    {
      id: '33',
      name: 'Counseling',
      levelId: 'skill_0',
    },
    {
      id: '38',
      name: 'Data Quality',
      levelId: 'skill_0',
    },
    {
      id: '122',
      name: 'Software Construction',
      levelId: 'skill_0',
    },
    {
      id: '130',
      name: 'Strategic Project Management',
      levelId: 'skill_0',
    },
  ];

// 12: rics_k50_12
export const GENERATED_DEFAULT_CUSTOM_SKILL_CUSTOM_12: SkillDefaultSelection[] =
  [
    {
      id: '15',
      name: 'Backend Development',
      levelId: 'skill_0',
    },
    {
      id: '41',
      name: 'Customer Relationship Management',
      levelId: 'skill_0',
    },
    {
      id: '44',
      name: 'Data Management',
      levelId: 'skill_0',
    },
    {
      id: '57',
      name: 'Employee Relations',
      levelId: 'skill_0',
    },
    {
      id: '113',
      name: 'Project Management Technical Skills',
      levelId: 'skill_0',
    },
  ];

// 13: rics_k50_13
export const GENERATED_DEFAULT_CUSTOM_SKILL_CUSTOM_13: SkillDefaultSelection[] =
  [
    {
      id: '8',
      name: 'Backend Development',
      levelId: 'skill_0',
    },
    {
      id: '43',
      name: 'Document Management',
      levelId: 'skill_0',
    },
    {
      id: '110',
      name: 'Project Management',
      levelId: 'skill_0',
    },
    {
      id: '125',
      name: 'Sales Development',
      levelId: 'skill_0',
    },
    {
      id: '134',
      name: 'Speech-Language Therapy',
      levelId: 'skill_0',
    },
  ];

// 14: rics_k50_14
export const GENERATED_DEFAULT_CUSTOM_SKILL_CUSTOM_14: SkillDefaultSelection[] =
  [
    {
      id: '7',
      name: 'B2B Sales',
      levelId: 'skill_0',
    },
    {
      id: '12',
      name: 'Business Forecasting',
      levelId: 'skill_0',
    },
    {
      id: '81',
      name: 'Java Development',
      levelId: 'skill_0',
    },
    {
      id: '114',
      name: 'Program & Project Management',
      levelId: 'skill_0',
    },
    {
      id: '141',
      name: 'Training Delivery',
      levelId: 'skill_0',
    },
  ];

// 15: rics_k50_15
export const GENERATED_DEFAULT_CUSTOM_SKILL_CUSTOM_15: SkillDefaultSelection[] =
  [
    {
      id: '45',
      name: 'Data Management',
      levelId: 'skill_0',
    },
    {
      id: '79',
      name: 'Java Web Development',
      levelId: 'skill_0',
    },
    {
      id: '105',
      name: 'PM Certification',
      levelId: 'skill_0',
    },
    {
      id: '111',
      name: 'Program Operations',
      levelId: 'skill_0',
    },
    {
      id: '127',
      name: 'Sales Technology',
      levelId: 'skill_0',
    },
  ];

// 16: rics_k50_16
export const GENERATED_DEFAULT_CUSTOM_SKILL_CUSTOM_16: SkillDefaultSelection[] =
  [
    {
      id: '33',
      name: 'Data Reporting',
      levelId: 'skill_0',
    },
    {
      id: '103',
      name: 'Programming',
      levelId: 'skill_0',
    },
    {
      id: '105',
      name: 'Project Planning',
      levelId: 'skill_0',
    },
    {
      id: '116',
      name: 'Sales Strategy',
      levelId: 'skill_0',
    },
    {
      id: '149',
      name: 'Workforce Training',
      levelId: 'skill_0',
    },
  ];

// 17: rics_k50_17
export const GENERATED_DEFAULT_CUSTOM_SKILL_CUSTOM_17: SkillDefaultSelection[] =
  [
    {
      id: '11',
      name: 'Business Analytics',
      levelId: 'skill_0',
    },
    {
      id: '17',
      name: 'Client Development',
      levelId: 'skill_0',
    },
    {
      id: '99',
      name: 'Organizational Development',
      levelId: 'skill_0',
    },
    {
      id: '112',
      name: 'Project Management Fundamentals',
      levelId: 'skill_0',
    },
    {
      id: '149',
      name: 'Web Development',
      levelId: 'skill_0',
    },
  ];

// 18: rics_k50_18
export const GENERATED_DEFAULT_CUSTOM_SKILL_CUSTOM_18: SkillDefaultSelection[] =
  [
    {
      id: '11',
      name: 'Business Development',
      levelId: 'skill_0',
    },
    {
      id: '16',
      name: 'Clinical Data Operations',
      levelId: 'skill_0',
    },
    {
      id: '112',
      name: 'Professional Training',
      levelId: 'skill_0',
    },
    {
      id: '114',
      name: 'Project Management Software',
      levelId: 'skill_0',
    },
    {
      id: '128',
      name: 'Software Programming',
      levelId: 'skill_0',
    },
  ];

// 19: rics_k50_19
export const GENERATED_DEFAULT_CUSTOM_SKILL_CUSTOM_19: SkillDefaultSelection[] =
  [
    {
      id: '1',
      name: 'Account Development',
      levelId: 'skill_0',
    },
    {
      id: '10',
      name: 'Business Analysis',
      levelId: 'skill_0',
    },
    {
      id: '32',
      name: 'Corporate Training',
      levelId: 'skill_0',
    },
    {
      id: '113',
      name: 'Project Management',
      levelId: 'skill_0',
    },
    {
      id: '131',
      name: 'Software Engineering',
      levelId: 'skill_0',
    },
  ];

// 20: rics_k50_20
export const GENERATED_DEFAULT_CUSTOM_SKILL_CUSTOM_20: SkillDefaultSelection[] =
  [
    {
      id: '14',
      name: 'Business Analysis',
      levelId: 'skill_0',
    },
    {
      id: '56',
      name: 'Full-Stack Development',
      levelId: 'skill_0',
    },
    {
      id: '106',
      name: 'Project Planning',
      levelId: 'skill_0',
    },
    {
      id: '117',
      name: 'Sales Process',
      levelId: 'skill_0',
    },
    {
      id: '139',
      name: 'Training and Development',
      levelId: 'skill_0',
    },
  ];

// 21: rics_k50_21
export const GENERATED_DEFAULT_CUSTOM_SKILL_CUSTOM_21: SkillDefaultSelection[] =
  [
    {
      id: '3',
      name: 'Application Development',
      levelId: 'skill_0',
    },
    {
      id: '8',
      name: 'Behavioral Support',
      levelId: 'skill_0',
    },
    {
      id: '16',
      name: 'Business Reporting',
      levelId: 'skill_0',
    },
    {
      id: '106',
      name: 'Project Methodologies',
      levelId: 'skill_0',
    },
    {
      id: '118',
      name: 'Sales Management',
      levelId: 'skill_0',
    },
  ];

// 22: rics_k50_22
export const GENERATED_DEFAULT_CUSTOM_SKILL_CUSTOM_22: SkillDefaultSelection[] =
  [
    {
      id: '16',
      name: 'Business Development',
      levelId: 'skill_0',
    },
    {
      id: '18',
      name: 'Business Performance Management',
      levelId: 'skill_0',
    },
    {
      id: '34',
      name: 'Construction Management',
      levelId: 'skill_0',
    },
    {
      id: '93',
      name: 'Mobile Software Development',
      levelId: 'skill_0',
    },
    {
      id: '137',
      name: 'Therapeutic Counseling',
      levelId: 'skill_0',
    },
  ];

// 23: rics_k50_23
export const GENERATED_DEFAULT_CUSTOM_SKILL_CUSTOM_23: SkillDefaultSelection[] =
  [
    {
      id: '26',
      name: 'Data Quality Assurance',
      levelId: 'skill_0',
    },
    {
      id: '47',
      name: 'Field Sales',
      levelId: 'skill_0',
    },
    {
      id: '102',
      name: 'Project Management',
      levelId: 'skill_0',
    },
    {
      id: '123',
      name: 'Social Services',
      levelId: 'skill_0',
    },
    {
      id: '148',
      name: 'Web Application Development',
      levelId: 'skill_0',
    },
  ];

// 24: rics_k50_24
export const GENERATED_DEFAULT_CUSTOM_SKILL_CUSTOM_24: SkillDefaultSelection[] =
  [
    {
      id: '24',
      name: 'Client Relations',
      levelId: 'skill_0',
    },
    {
      id: '47',
      name: 'Data Processing',
      levelId: 'skill_0',
    },
    {
      id: '110',
      name: 'Project Delivery',
      levelId: 'skill_0',
    },
    {
      id: '131',
      name: 'Student Affairs',
      levelId: 'skill_0',
    },
    {
      id: '147',
      name: 'Web Development',
      levelId: 'skill_0',
    },
  ];

// 25: rics_k50_25
export const GENERATED_DEFAULT_CUSTOM_SKILL_CUSTOM_25: SkillDefaultSelection[] =
  [
    {
      id: '20',
      name: 'Child and Adolescent Education',
      levelId: 'skill_0',
    },
    {
      id: '78',
      name: 'Information Processing',
      levelId: 'skill_0',
    },
    {
      id: '79',
      name: 'Insurance Sales',
      levelId: 'skill_0',
    },
    {
      id: '109',
      name: 'Project Management Fundamentals',
      levelId: 'skill_0',
    },
    {
      id: '125',
      name: 'Software Engineering',
      levelId: 'skill_0',
    },
  ];

// 26: rics_k50_26
export const GENERATED_DEFAULT_CUSTOM_SKILL_CUSTOM_26: SkillDefaultSelection[] =
  [
    {
      id: '42',
      name: 'Data Management',
      levelId: 'skill_0',
    },
    {
      id: '67',
      name: 'HR Services',
      levelId: 'skill_0',
    },
    {
      id: '113',
      name: 'Project Management',
      levelId: 'skill_0',
    },
    {
      id: '130',
      name: 'Sales Execution',
      levelId: 'skill_0',
    },
    {
      id: '147',
      name: 'Web Development',
      levelId: 'skill_0',
    },
  ];

// 27: rics_k50_27
export const GENERATED_DEFAULT_CUSTOM_SKILL_CUSTOM_27: SkillDefaultSelection[] =
  [
    {
      id: '20',
      name: 'Client Services',
      levelId: 'skill_0',
    },
    {
      id: '27',
      name: 'Construction Project Controls',
      levelId: 'skill_0',
    },
    {
      id: '78',
      name: 'Java Development',
      levelId: 'skill_0',
    },
    {
      id: '131',
      name: 'Spreadsheet Analytics',
      levelId: 'skill_0',
    },
    {
      id: '142',
      name: 'Training and Development',
      levelId: 'skill_0',
    },
  ];

// 28: rics_k50_28
export const GENERATED_DEFAULT_CUSTOM_SKILL_CUSTOM_28: SkillDefaultSelection[] =
  [
    {
      id: '6',
      name: 'Application Frameworks',
      levelId: 'skill_0',
    },
    {
      id: '13',
      name: 'Business Intelligence',
      levelId: 'skill_0',
    },
    {
      id: '22',
      name: 'Construction Project Controls',
      levelId: 'skill_0',
    },
    {
      id: '84',
      name: 'Member Services',
      levelId: 'skill_0',
    },
    {
      id: '146',
      name: 'Workforce Development',
      levelId: 'skill_0',
    },
  ];

// 29: rics_k50_29
export const GENERATED_DEFAULT_CUSTOM_SKILL_CUSTOM_29: SkillDefaultSelection[] =
  [
    {
      id: '41',
      name: 'Counseling Skills',
      levelId: 'skill_0',
    },
    {
      id: '82',
      name: 'Java Backend Development',
      levelId: 'skill_0',
    },
    {
      id: '99',
      name: 'Operations Planning',
      levelId: 'skill_0',
    },
    {
      id: '109',
      name: 'Project Execution',
      levelId: 'skill_0',
    },
    {
      id: '128',
      name: 'Sales Operations',
      levelId: 'skill_0',
    },
  ];

// 30: rics_k50_30
export const GENERATED_DEFAULT_CUSTOM_SKILL_CUSTOM_30: SkillDefaultSelection[] =
  [
    {
      id: '1',
      name: 'Account Management',
      levelId: 'skill_0',
    },
    {
      id: '37',
      name: 'Data Management',
      levelId: 'skill_0',
    },
    {
      id: '106',
      name: 'Project Management Tools',
      levelId: 'skill_0',
    },
    {
      id: '124',
      name: 'Software Programming',
      levelId: 'skill_0',
    },
    {
      id: '139',
      name: 'Training and Development',
      levelId: 'skill_0',
    },
  ];

// 31: rics_k50_31
export const GENERATED_DEFAULT_CUSTOM_SKILL_CUSTOM_31: SkillDefaultSelection[] =
  [
    {
      id: '14',
      name: 'Business Data Analysis',
      levelId: 'skill_0',
    },
    {
      id: '24',
      name: 'Community Engagement',
      levelId: 'skill_0',
    },
    {
      id: '49',
      name: 'Enterprise Project Management',
      levelId: 'skill_0',
    },
    {
      id: '51',
      name: 'Enterprise Sales',
      levelId: 'skill_0',
    },
    {
      id: '76',
      name: 'Java Development',
      levelId: 'skill_0',
    },
  ];

// 32: rics_k50_32
export const GENERATED_DEFAULT_CUSTOM_SKILL_CUSTOM_32: SkillDefaultSelection[] =
  [
    {
      id: '2',
      name: 'Account Management',
      levelId: 'skill_0',
    },
    {
      id: '48',
      name: 'Education and Training',
      levelId: 'skill_0',
    },
    {
      id: '59',
      name: 'Excel Analytics',
      levelId: 'skill_0',
    },
    {
      id: '78',
      name: 'Java Development',
      levelId: 'skill_0',
    },
    {
      id: '121',
      name: 'Project Execution',
      levelId: 'skill_0',
    },
  ];

// 33: rics_k50_33
export const GENERATED_DEFAULT_CUSTOM_SKILL_CUSTOM_33: SkillDefaultSelection[] =
  [
    {
      id: '19',
      name: 'Client Development',
      levelId: 'skill_0',
    },
    {
      id: '62',
      name: 'Financial Modeling',
      levelId: 'skill_0',
    },
    {
      id: '107',
      name: 'Project Management Fundamentals',
      levelId: 'skill_0',
    },
    {
      id: '129',
      name: 'Social Services Case Management',
      levelId: 'skill_0',
    },
    {
      id: '131',
      name: 'Software Engineering',
      levelId: 'skill_0',
    },
  ];

// 34: rics_k50_34
export const GENERATED_DEFAULT_CUSTOM_SKILL_CUSTOM_34: SkillDefaultSelection[] =
  [
    {
      id: '5',
      name: 'Application Development',
      levelId: 'skill_0',
    },
    {
      id: '18',
      name: 'Business Development',
      levelId: 'skill_0',
    },
    {
      id: '36',
      name: 'Counseling Services',
      levelId: 'skill_0',
    },
    {
      id: '39',
      name: 'Data Management',
      levelId: 'skill_0',
    },
    {
      id: '132',
      name: 'Strategic Project Management',
      levelId: 'skill_0',
    },
  ];

// 35: rics_k50_35
export const GENERATED_DEFAULT_CUSTOM_SKILL_CUSTOM_35: SkillDefaultSelection[] =
  [
    {
      id: '9',
      name: 'B2B Sales',
      levelId: 'skill_0',
    },
    {
      id: '10',
      name: 'Backend Development',
      levelId: 'skill_0',
    },
    {
      id: '36',
      name: 'Data Quality',
      levelId: 'skill_0',
    },
    {
      id: '105',
      name: 'Project Planning',
      levelId: 'skill_0',
    },
    {
      id: '128',
      name: 'Sports and Fitness',
      levelId: 'skill_0',
    },
  ];

// 36: rics_k50_36
export const GENERATED_DEFAULT_CUSTOM_SKILL_CUSTOM_36: SkillDefaultSelection[] =
  [
    {
      id: '14',
      name: 'Business Development',
      levelId: 'skill_0',
    },
    {
      id: '33',
      name: 'Data Operations',
      levelId: 'skill_0',
    },
    {
      id: '54',
      name: 'Full-Stack Development',
      levelId: 'skill_0',
    },
    {
      id: '104',
      name: 'Personal Care',
      levelId: 'skill_0',
    },
    {
      id: '116',
      name: 'Project Planning',
      levelId: 'skill_0',
    },
  ];

// 37: rics_k50_37
export const GENERATED_DEFAULT_CUSTOM_SKILL_CUSTOM_37: SkillDefaultSelection[] =
  [
    {
      id: '13',
      name: 'Business Analytics',
      levelId: 'skill_0',
    },
    {
      id: '109',
      name: 'Project Management Methods',
      levelId: 'skill_0',
    },
    {
      id: '123',
      name: 'Sales Techniques',
      levelId: 'skill_0',
    },
    {
      id: '127',
      name: 'Software Engineering',
      levelId: 'skill_0',
    },
    {
      id: '142',
      name: 'Training and Development',
      levelId: 'skill_0',
    },
  ];

// 39: rics_k50_39
export const GENERATED_DEFAULT_CUSTOM_SKILL_CUSTOM_39: SkillDefaultSelection[] =
  [
    {
      id: '8',
      name: 'Backend Development',
      levelId: 'skill_0',
    },
    {
      id: '11',
      name: 'Business Intelligence',
      levelId: 'skill_0',
    },
    {
      id: '108',
      name: 'Personal Support Services',
      levelId: 'skill_0',
    },
    {
      id: '125',
      name: 'Sales Process',
      levelId: 'skill_0',
    },
    {
      id: '142',
      name: 'Technical PM Delivery',
      levelId: 'skill_0',
    },
  ];

// 40: rics_k50_40
export const GENERATED_DEFAULT_CUSTOM_SKILL_CUSTOM_40: SkillDefaultSelection[] =
  [
    {
      id: '12',
      name: 'Business Development',
      levelId: 'skill_0',
    },
    {
      id: '50',
      name: 'HR Administration',
      levelId: 'skill_0',
    },
    {
      id: '62',
      name: 'Information Management',
      levelId: 'skill_0',
    },
    {
      id: '110',
      name: 'Project Management Tools',
      levelId: 'skill_0',
    },
    {
      id: '126',
      name: 'Software Programming',
      levelId: 'skill_0',
    },
  ];

// 41: rics_k50_41
export const GENERATED_DEFAULT_CUSTOM_SKILL_CUSTOM_41: SkillDefaultSelection[] =
  [
    {
      id: '6',
      name: 'Application Development',
      levelId: 'skill_0',
    },
    {
      id: '19',
      name: 'Career Development',
      levelId: 'skill_0',
    },
    {
      id: '59',
      name: 'Excel Data Analysis',
      levelId: 'skill_0',
    },
    {
      id: '118',
      name: 'Program Management',
      levelId: 'skill_0',
    },
    {
      id: '128',
      name: 'Sales Processes',
      levelId: 'skill_0',
    },
  ];

// 42: rics_k50_42
export const GENERATED_DEFAULT_CUSTOM_SKILL_CUSTOM_42: SkillDefaultSelection[] =
  [
    {
      id: '59',
      name: 'Financial Systems',
      levelId: 'skill_0',
    },
    {
      id: '79',
      name: 'Java Development',
      levelId: 'skill_0',
    },
    {
      id: '114',
      name: 'Program Coordination',
      levelId: 'skill_0',
    },
    {
      id: '116',
      name: 'Project Planning',
      levelId: 'skill_0',
    },
    {
      id: '128',
      name: 'Sales Techniques',
      levelId: 'skill_0',
    },
  ];

// 43: rics_k50_43
export const GENERATED_DEFAULT_CUSTOM_SKILL_CUSTOM_43: SkillDefaultSelection[] =
  [
    {
      id: '4',
      name: 'Administrative Procedures',
      levelId: 'skill_0',
    },
    {
      id: '7',
      name: 'Application Development',
      levelId: 'skill_0',
    },
    {
      id: '17',
      name: 'Career Services',
      levelId: 'skill_0',
    },
    {
      id: '67',
      name: 'IT Project Management',
      levelId: 'skill_0',
    },
    {
      id: '113',
      name: 'Sales Techniques',
      levelId: 'skill_0',
    },
  ];

// 44: rics_k50_44
export const GENERATED_DEFAULT_CUSTOM_SKILL_CUSTOM_44: SkillDefaultSelection[] =
  [
    {
      id: '14',
      name: 'Business Development',
      levelId: 'skill_0',
    },
    {
      id: '35',
      name: 'Data Management',
      levelId: 'skill_0',
    },
    {
      id: '37',
      name: 'Development Tools & APIs',
      levelId: 'skill_0',
    },
    {
      id: '115',
      name: 'Project Management',
      levelId: 'skill_0',
    },
    {
      id: '149',
      name: 'Wellness Instruction',
      levelId: 'skill_0',
    },
  ];

// 45: rics_k50_45
export const GENERATED_DEFAULT_CUSTOM_SKILL_CUSTOM_45: SkillDefaultSelection[] =
  [
    {
      id: '93',
      name: 'Office Administration',
      levelId: 'skill_0',
    },
    {
      id: '104',
      name: 'Project Management Practices',
      levelId: 'skill_0',
    },
    {
      id: '113',
      name: 'Sales Fundamentals',
      levelId: 'skill_0',
    },
    {
      id: '126',
      name: 'Spreadsheet Reporting',
      levelId: 'skill_0',
    },
    {
      id: '148',
      name: 'Web Application Development',
      levelId: 'skill_0',
    },
  ];

// 46: rics_k50_46
export const GENERATED_DEFAULT_CUSTOM_SKILL_CUSTOM_46: SkillDefaultSelection[] =
  [
    {
      id: '32',
      name: 'Data Operations',
      levelId: 'skill_0',
    },
    {
      id: '110',
      name: 'Project Controls',
      levelId: 'skill_0',
    },
    {
      id: '112',
      name: 'Psychosocial Support',
      levelId: 'skill_0',
    },
    {
      id: '121',
      name: 'Sales Strategy',
      levelId: 'skill_0',
    },
    {
      id: '148',
      name: 'Web Application Development',
      levelId: 'skill_0',
    },
  ];

// 47: rics_k50_47
export const GENERATED_DEFAULT_CUSTOM_SKILL_CUSTOM_47: SkillDefaultSelection[] =
  [
    {
      id: '5',
      name: 'Application Development',
      levelId: 'skill_0',
    },
    {
      id: '13',
      name: 'Business Reporting',
      levelId: 'skill_0',
    },
    {
      id: '110',
      name: 'Project Management',
      levelId: 'skill_0',
    },
    {
      id: '123',
      name: 'Sales Techniques',
      levelId: 'skill_0',
    },
    {
      id: '131',
      name: 'Staff Management',
      levelId: 'skill_0',
    },
  ];

// 48: rics_k50_48
export const GENERATED_DEFAULT_CUSTOM_SKILL_CUSTOM_48: SkillDefaultSelection[] =
  [
    {
      id: '12',
      name: 'BI Data Analysis',
      levelId: 'skill_0',
    },
    {
      id: '97',
      name: 'Organizational Development',
      levelId: 'skill_0',
    },
    {
      id: '110',
      name: 'Project Management',
      levelId: 'skill_0',
    },
    {
      id: '123',
      name: 'Sales Execution',
      levelId: 'skill_0',
    },
    {
      id: '147',
      name: 'Web Application Engineering',
      levelId: 'skill_0',
    },
  ];

// 49: rics_k50_49
export const GENERATED_DEFAULT_CUSTOM_SKILL_CUSTOM_49: SkillDefaultSelection[] =
  [
    {
      id: '13',
      name: 'Business Development',
      levelId: 'skill_0',
    },
    {
      id: '36',
      name: 'Data Operations',
      levelId: 'skill_0',
    },
    {
      id: '53',
      name: 'Full-Stack Development',
      levelId: 'skill_0',
    },
    {
      id: '107',
      name: 'Project Delivery',
      levelId: 'skill_0',
    },
    {
      id: '125',
      name: 'Soft Skills',
      levelId: 'skill_0',
    },
  ];

// 50: rics_k50_50
export const GENERATED_DEFAULT_CUSTOM_SKILL_CUSTOM_50: SkillDefaultSelection[] =
  [
    {
      id: '7',
      name: 'Application Programming',
      levelId: 'skill_0',
    },
    {
      id: '27',
      name: 'Caregiving',
      levelId: 'skill_0',
    },
    {
      id: '44',
      name: 'Data Analysis',
      levelId: 'skill_0',
    },
    {
      id: '109',
      name: 'Project Management Tools',
      levelId: 'skill_0',
    },
    {
      id: '125',
      name: 'Sales Strategy',
      levelId: 'skill_0',
    },
  ];

// 51: rics_k10_1
export const GENERATED_DEFAULT_CUSTOM_SKILL_CUSTOM_51: SkillDefaultSelection[] =
  [
    {
      id: '15',
      name: 'Business Reporting',
      levelId: 'skill_0',
    },
    {
      id: '68',
      name: 'IT Project Management',
      levelId: 'skill_0',
    },
    {
      id: '109',
      name: 'Programming',
      levelId: 'skill_0',
    },
    {
      id: '122',
      name: 'Sales Skills',
      levelId: 'skill_0',
    },
    {
      id: '142',
      name: 'Training Program Design',
      levelId: 'skill_0',
    },
  ];

// 52: rics_k10_2
export const GENERATED_DEFAULT_CUSTOM_SKILL_CUSTOM_52: SkillDefaultSelection[] =
  [
    {
      id: '9',
      name: 'Backend Engineering',
      levelId: 'skill_0',
    },
    {
      id: '63',
      name: 'Financial Systems',
      levelId: 'skill_0',
    },
    {
      id: '122',
      name: 'Sales Fundamentals',
      levelId: 'skill_0',
    },
    {
      id: '129',
      name: 'Social Services Administration',
      levelId: 'skill_0',
    },
    {
      id: '137',
      name: 'Strategic Project Management',
      levelId: 'skill_0',
    },
  ];

// 53: rics_k10_3
export const GENERATED_DEFAULT_CUSTOM_SKILL_CUSTOM_53: SkillDefaultSelection[] =
  [
    {
      id: '25',
      name: 'Construction Project Planning',
      levelId: 'skill_0',
    },
    {
      id: '52',
      name: 'Financial Systems',
      levelId: 'skill_0',
    },
    {
      id: '122',
      name: 'Sales Management',
      levelId: 'skill_0',
    },
    {
      id: '132',
      name: 'Staff Development',
      levelId: 'skill_0',
    },
    {
      id: '148',
      name: 'Web Development',
      levelId: 'skill_0',
    },
  ];

// 54: rics_k10_4
export const GENERATED_DEFAULT_CUSTOM_SKILL_CUSTOM_54: SkillDefaultSelection[] =
  [
    {
      id: '13',
      name: 'Business Development',
      levelId: 'skill_0',
    },
    {
      id: '42',
      name: 'Document Services',
      levelId: 'skill_0',
    },
    {
      id: '83',
      name: 'JavaScript Development',
      levelId: 'skill_0',
    },
    {
      id: '87',
      name: 'Leadership Development',
      levelId: 'skill_0',
    },
    {
      id: '113',
      name: 'Project Management Essentials',
      levelId: 'skill_0',
    },
  ];

// 55: rics_k10_5
export const GENERATED_DEFAULT_CUSTOM_SKILL_CUSTOM_55: SkillDefaultSelection[] =
  [
    {
      id: '12',
      name: 'Business Intelligence',
      levelId: 'skill_0',
    },
    {
      id: '80',
      name: 'Housing Administration',
      levelId: 'skill_0',
    },
    {
      id: '122',
      name: 'Project Management Systems',
      levelId: 'skill_0',
    },
    {
      id: '131',
      name: 'Sales Management',
      levelId: 'skill_0',
    },
    {
      id: '133',
      name: 'Software Engineering',
      levelId: 'skill_0',
    },
  ];

// 56: rics_k10_6
export const GENERATED_DEFAULT_CUSTOM_SKILL_CUSTOM_56: SkillDefaultSelection[] =
  [
    {
      id: '60',
      name: 'Financial Recording',
      levelId: 'skill_0',
    },
    {
      id: '114',
      name: 'Project Planning',
      levelId: 'skill_0',
    },
    {
      id: '127',
      name: 'Sales Operations',
      levelId: 'skill_0',
    },
    {
      id: '132',
      name: 'Software Engineering',
      levelId: 'skill_0',
    },
    {
      id: '150',
      name: 'Workforce Training',
      levelId: 'skill_0',
    },
  ];

// 57: rics_k10_7
export const GENERATED_DEFAULT_CUSTOM_SKILL_CUSTOM_57: SkillDefaultSelection[] =
  [
    {
      id: '19',
      name: 'Client Development',
      levelId: 'skill_0',
    },
    {
      id: '62',
      name: 'Financial Modeling',
      levelId: 'skill_0',
    },
    {
      id: '107',
      name: 'Project Management Fundamentals',
      levelId: 'skill_0',
    },
    {
      id: '129',
      name: 'Social Services Case Management',
      levelId: 'skill_0',
    },
    {
      id: '131',
      name: 'Software Engineering',
      levelId: 'skill_0',
    },
  ];

// 58: rics_k10_8
export const GENERATED_DEFAULT_CUSTOM_SKILL_CUSTOM_58: SkillDefaultSelection[] =
  [
    {
      id: '13',
      name: 'Backend Development',
      levelId: 'skill_0',
    },
    {
      id: '31',
      name: 'Communication Skills',
      levelId: 'skill_0',
    },
    {
      id: '49',
      name: 'Document Processing',
      levelId: 'skill_0',
    },
    {
      id: '56',
      name: 'Enterprise Project Management',
      levelId: 'skill_0',
    },
    {
      id: '58',
      name: 'Enterprise Sales',
      levelId: 'skill_0',
    },
  ];

// 59: rics_k10_9
export const GENERATED_DEFAULT_CUSTOM_SKILL_CUSTOM_59: SkillDefaultSelection[] =
  [
    {
      id: '25',
      name: 'Coaching',
      levelId: 'skill_0',
    },
    {
      id: '40',
      name: 'Data Management',
      levelId: 'skill_0',
    },
    {
      id: '116',
      name: 'Sales',
      levelId: 'skill_0',
    },
    {
      id: '120',
      name: 'Software Engineering',
      levelId: 'skill_0',
    },
    {
      id: '126',
      name: 'Strategic Programme Management',
      levelId: 'skill_0',
    },
  ];

// 60: rics_k10_10
export const GENERATED_DEFAULT_CUSTOM_SKILL_CUSTOM_60: SkillDefaultSelection[] =
  [
    {
      id: '13',
      name: 'Business Development',
      levelId: 'skill_0',
    },
    {
      id: '36',
      name: 'Data Operations',
      levelId: 'skill_0',
    },
    {
      id: '53',
      name: 'Full-Stack Development',
      levelId: 'skill_0',
    },
    {
      id: '107',
      name: 'Project Delivery',
      levelId: 'skill_0',
    },
    {
      id: '125',
      name: 'Soft Skills',
      levelId: 'skill_0',
    },
  ];

// 61: onet
export const GENERATED_DEFAULT_CUSTOM_SKILL_CUSTOM_61: SkillDefaultSelection[] =
  [
    {
      id: '27',
      name: '2.C.1: Business and Management',
      levelId: 'skill_0',
    },
    {
      id: '58',
      name: '4.A.2: Mental Processes',
      levelId: 'skill_0',
    },
    {
      id: '60',
      name: '4.A.4: Interacting With Others',
      levelId: 'skill_0',
    },
  ];

// 62: esco
export const GENERATED_DEFAULT_CUSTOM_SKILL_CUSTOM_62: SkillDefaultSelection[] =
  [
    {
      id: '17',
      name: 'S1: communication, collaboration and creativity',
      levelId: 'skill_0',
    },
    {
      id: '18',
      name: 'S2: information skills',
      levelId: 'skill_0',
    },
    {
      id: '20',
      name: 'S4: management skills',
      levelId: 'skill_0',
    },
  ];

// 63: lightcast
export const GENERATED_DEFAULT_CUSTOM_SKILL_CUSTOM_63: SkillDefaultSelection[] =
  [
    {
      id: '1',
      name: 'Account Management',
      levelId: 'skill_0',
    },
    {
      id: '237',
      name: 'Java',
      levelId: 'skill_0',
    },
    {
      id: '310',
      name: 'Office and Productivity Equipment and Technology',
      levelId: 'skill_0',
    },
    {
      id: '350',
      name: 'Project Management',
      levelId: 'skill_0',
    },
    {
      id: '412',
      name: 'Teaching',
      levelId: 'skill_0',
    },
  ];
